import "./utility-tools.css";
import QRCode from "qrcode";
import { canvasBlob } from "./bmp-browser.js";
import { createOperationResult } from "./operation-result.js";

const root = document.querySelector("[data-qr-generator]");

if (root) {
  const ids = ["qrStatus", "qrWorkspace", "qrPreview", "qrText", "qrCorrection", "qrSize", "downloadQrPng", "downloadQrSvg"];
  const elements = Object.fromEntries(ids.map(id => [id, document.getElementById(id)]));
  const result = createOperationResult(root, elements.qrWorkspace);
  let renderToken = 0;

  function status(message = "") { elements.qrStatus.textContent = message; elements.qrStatus.hidden = !message; }
  function options(width = 320) { return { errorCorrectionLevel: elements.qrCorrection.value, width, margin: 3, color: { dark: "#10182b", light: "#ffffff" } }; }
  function value() {
    const text = elements.qrText.value.trim();
    if (!text) throw new Error("Enter text or a URL to encode.");
    return text;
  }

  async function preview() {
    const token = ++renderToken;
    try {
      const text = value();
      await QRCode.toCanvas(elements.qrPreview, text, options(320));
      if (token === renderToken) status();
    } catch (error) {
      if (token === renderToken) status(error?.message || "The QR code could not be generated.");
    }
  }

  async function create(type) {
    try {
      const text = value();
      const width = Number(elements.qrSize.value);
      if (type === "svg") {
        const svg = await QRCode.toString(text, { ...options(width), type: "svg" });
        result.show({ blob: new Blob([svg], { type: "image/svg+xml" }), fileName: "qr-code.svg", message: "Your QR code is ready.", details: [`SVG · ${width} px viewbox`], downloadLabel: "Download SVG" });
      } else {
        const canvas = document.createElement("canvas");
        await QRCode.toCanvas(canvas, text, options(width));
        result.show({ blob: await canvasBlob(canvas, "image/png"), fileName: "qr-code.png", message: "Your QR code is ready.", details: [`PNG · ${width} × ${width} px`], downloadLabel: "Download PNG" });
      }
    } catch (error) {
      status(error?.message || "The QR code could not be generated.");
    }
  }

  elements.qrText.addEventListener("input", preview);
  elements.qrCorrection.addEventListener("change", preview);
  elements.downloadQrPng.addEventListener("click", () => create("png"));
  elements.downloadQrSvg.addEventListener("click", () => create("svg"));
  preview();
}
